<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li *ngIf="!isAdmin"><a>{{company_name}}:</a></li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a>
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <mat-toolbar class="top_headerbar">
    <div class="right">
      <div class="all_action_btns">
      
          <div  *ngIf="isAdmin" class="custom_search width_200">
            <span class="sprite_icon search"></span>
            <input
              type="text"
              class="form-control"
              placeholder="Search by Company Name"
              [(ngModel)]="companyName"
              (input)="searchByCompanyName($event.target.value)"
            />
          </div>
          <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Site Name"
            [(ngModel)]="siteName"
            (input)="searchBySiteName($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Asset Name"
            [(ngModel)]="assetName"
            (input)="searchByAssetName($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Application Name"
            [(ngModel)]="applicationName"
            (input)="searchByApplicationName($event.target.value)"
          />
        </div>
      
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by MacAddress"
            [(ngModel)]="macAddress"
            (input)="searchByMacAddress($event.target.value)"
          />
        </div>
    
        <!-- Second Search Input (Search by Serial Number) -->
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Serial Number"
            [(ngModel)]="serialNumber"
            (input)="searchBySerialNumber($event.target.value)"
          />
        </div>
      
      </div>
    
      <!-- Radio buttons for Today, This Week, and This Month -->
      <div class="radio-buttons">
        <label class="radio-label">
          <input
            type="radio"
            name="timePeriod"
            value="today"
            [(ngModel)]="selectedPeriod"
            (change)="onPeriodChange()"
          />
          Today
        </label>
        <label class="radio-label">
          <input
            type="radio"
            name="timePeriod"
            value="weekly"
            [(ngModel)]="selectedPeriod"
            (change)="onPeriodChange()"
          />
          This Week
        </label>
        <label class="radio-label">
          <input
            type="radio"
            name="timePeriod"
            value="monthly"
            [(ngModel)]="selectedPeriod"
            (change)="onPeriodChange()"
          />
          This Month
        </label>
      </div>
    </div>
    
    
  </mat-toolbar>
  <div class="asset_list_view_outer" id="table-to-print">
    <div class="list_view_outer">
      <div class="table-responsive">
        <table class="table left-align-table table-hover" style="border-collapse: collapse;" *ngIf="processedData?.length > 0 && !isAdmin " style="table-layout: fixed; width: 100%;">
          <thead>
            <tr>
              <th>Site Name</th>
              <th>Application Name</th>
              <th>Asset Name</th>
              <th>Device Serial No.</th>
              <th>Mac Address</th>
              <th>Total Alerts</th>
              <th style="width: 50px;"></th> <!-- Fixed width for the button column -->
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && processedData?.length > 0" >
            <!-- Show a message if no filter has been applied -->
            <tr *ngIf="isFiltered && filteredData?.length === 0">
              <td colspan="6" class="text-center">No results found for your filter.</td>
            </tr>
        
            <!-- Show filtered data if available -->
            <ng-container *ngIf="isFiltered; else showProcessedData">
              <ng-container *ngFor="let alert of filteredData; let idx = index">
                <tr (click)="toggleDetails(idx)" class="cursor-pointer">
                  <td>{{ alert?.site_name || "N/A" }}</td>
                  <td>{{ alert?.application_name || "N/A" }}</td>
                  <td>{{ alert?.asset_name || "N/A" }}</td>
                  <td>{{ alert?.device_serial_no || "N/A" }}</td>
                  <td>{{ alert?.mac_address || "N/A" }}</td>
                  <td>{{ alert?.count }}</td>
                  <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                    <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                            [ngClass]="{'rotate-180': activeIndex === idx}" 
                            (click)="toggleDetails(idx)">
                      <svg (click)="$event.stopPropagation(); toggleDetails(idx)"
                           viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                           width="30" height="30">
                        <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"></path>
                      </svg>
                    </button>
                  </td>
                </tr>
        
                <!-- Hidden Details Row -->
                <tr *ngIf="activeIndex === idx">
                  <td colspan="6">
                    <div class="p-3">
                      <table class="w-100 left-align-color left-align-table">
                        <thead style="background-color: #0066bf; color: white;">
                          <tr style="background-color: #0066bf; color: white;" >
                            <th style="background-color: #0066bf; color: white;" >Alert Details</th>
                            <th style="background-color: #0066bf; color: white;">Date & Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let alert of filteredData[idx].data; let subIdx = index" class="cursor-pointer">
                            <td>{{ alert?.alert_details || "N/A" }}</td>
                            <td>{{ formatDate(alert.alert_time) || "N/A" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
        
            <!-- Show processed data if no filter is applied -->
            <ng-template  #showProcessedData>
              <ng-container  *ngFor="let alert of processedData; let idx = index">
                <tr (click)="toggleDetails(idx)" class="cursor-pointer">
                  <td>{{ alert?.site_name || "N/A" }}</td>
                  <td>{{ alert?.application_name || "N/A" }}</td>
                  <td>{{ alert?.asset_name || "N/A" }}</td>
                  <td>{{ alert?.device_serial_no || "N/A" }}</td>
                  <td>{{ alert?.mac_address || "N/A" }}</td>
                  <td>{{ alert?.count }}</td>
                  <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                    <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                            [ngClass]="{'rotate-180': activeIndex === idx}" 
                            (click)="toggleDetails(idx)">
                      <svg (click)="$event.stopPropagation(); toggleDetails(idx)"
                           viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                           width="30" height="30">
                        <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"></path>
                      </svg>
                    </button>
                  </td>
                </tr>
        
                <!-- Hidden Details Row -->
                <tr *ngIf="activeIndex === idx">
                  <td colspan="6">
                    <div class="p-3">
                      <table class="w-100 left-align-color left-align-table">
                        <thead style="background-color: #0066bf; color: white;">
                          <tr style="background-color: #0066bf; color: white;">
                            <th style="background-color: #0066bf; color: white;">Alert Details</th>
                            <th style="background-color: #0066bf; color: white;">Date & Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let alert of processedData[idx].data; let subIdx = index" class="cursor-pointer">
                            <td>{{ alert?.alert_details || "N/A" }}</td>
                            <td>{{ formatDate(alert.alert_time) || "N/A" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
          </tbody>
        </table>
          <!-- Main Table (Parent Table) - Visible only if isAdmin is true -->
          <table *ngIf="processedData?.length > 0 && isAdmin" class="table left-align-table table-hover" style="table-layout: fixed; width: 100%;">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Total Alerts</th>
                <th style="width: 50px;"></th> <!-- Fixed width for the button column -->
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isFiltered && filteredData?.length === 0">
                <td colspan="3" class="text-center">No results found for your filter.</td>
              </tr>
              <!-- Show filtered data if available -->
              <ng-container *ngIf="isFiltered; else showProcessedData">
                <ng-container *ngFor="let alert of filteredData; let idx = index">
                  <!-- Outer Row -->
                  
                  <tr *ngIf="!isLoading && filteredData?.length > 0"  (click)="toggleInnerDetails(idx)" class="cursor-pointer">
                    <td class="bold-text">{{ alert?.client_name || "N/A" }}</td>
                    <td  class="bold-text">{{ alert?.client_sub_total || "N/A" }}</td>
                    <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                      <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                              [ngClass]="{'rotate-180': activeInnerIndex === idx}" 
                              (click)="$event.stopPropagation(); toggleInnerDetails(idx)">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
                          <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="#0F0F0F"></path>
                        </svg>
                      </button>
                    </td>
                  </tr>
          
                  <!-- First Child Table (Mac Address Details) -->
                  <tr *ngIf="activeInnerIndex === idx && !isLoading">
                    <td colspan="3">
                      <div class="p-3">
                        <table class="w-100 left-align-color left-align-table">
                          <thead style="background-color: #0066bf; color: white;">
                            <tr>
                              <th>Site Name</th>
                              <th>Application Name</th>
                              <th>Asset Name</th>
                              <th>Device Serial No.</th>
                              <th>Mac Address</th>
                              <th>Total Alerts</th>
                              <th style="width: 50px;"></th> <!-- Fixed width for the button column -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let detail of alert.alerts; let subIdx = index"  (click)="openModal(detail,subIdx)">
                              <td>{{ detail?.site_name || "N/A" }}</td>
                              <td>{{ detail?.application_name || "N/A" }}</td>
                              <td>{{ detail?.asset_name || "N/A" }}</td>
                              <td>{{ detail?.device_serial_no || "N/A" }}</td>
                              <td>{{ detail?.mac_address || "N/A" }}</td>
                              <td>{{ detail?.count || "N/A" }}</td>
                              <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                                <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                                [ngClass]="{'active-eye': activeIndex === subIdx}" 
                                (click)="$event.stopPropagation(); openModal(detail,subIdx)">
                            <svg viewBox="0 0 24 24" width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path *ngIf="activeIndex !== subIdx" 
                                      d="M12 4.5C7.455 4.5 3.733 7.418 2 12c1.733 4.582 5.455 7.5 10 7.5s8.267-2.918 10-7.5c-1.733-4.582-5.455-7.5-10-7.5Zm0 12.5c-2.627 0-4.75-2.123-4.75-4.75S9.373 7.5 12 7.5s4.75 2.123 4.75 4.75-2.123 4.75-4.75 4.75Zm0-2c1.518 0 2.75-1.232 2.75-2.75S13.518 9.5 12 9.5 9.25 10.732 9.25 12.25 10.482 15 12 15Z" 
                                      fill="#0F0F0F"/>
                                <path *ngIf="activeIndex === subIdx"
                                      d="M12 3C7 3 2.732 6.732 1 12c1.732 5.268 6 9 11 9s9.268-3.732 11-9c-1.732-5.268-6-9-11-9Zm0 15c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6Zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Z" 
                                      fill="#0066bf"/>
                            </svg>
                        </button>
                        
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
          
                  <!-- Second Child Table (Alert Details) -->
                  <div *ngIf="selectedAlert" class="modal-overlay" (click)="closeModal()">
                    <div class="modal-content" (click)="$event.stopPropagation()">
                      <!-- Fixed Close Button with Cross -->
                      <button class="cancel-button" (click)="closeModal()">
                        <span class="cross-icon">&times;</span>
                      </button>
                  
                      <!-- Fixed Table Header -->
                      <div class="fixed-header">
                        <table class="table-fixed left-align-color left-align-table">
                          <thead style="background-color: #0066bf; color: white;">
                            <tr>
                              <th class="col-details">Alert Details</th>
                              <th class="col-datetime">Date &amp; Time</th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                      
                      <!-- Scrollable Body Table -->
                      <div class="scrollable-body">
                        <table class="table-fixed left-align-color left-align-table">
                          <tbody>
                            <tr *ngFor="let alertDetail of selectedAlert.data">
                              <td class="col-details">{{ alertDetail?.alert_details || "N/A" }}</td>
                              <td class="col-datetime">{{ formatDate(alertDetail?.alert_time) || "N/A" }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
          
              <!-- Show processed data if no filter is applied -->
              <ng-template #showProcessedData>
                <ng-container *ngFor="let alert of processedData; let idx = index">
                  <!-- Outer Row -->
                  <tr *ngIf="!isLoading && processedData?.length > 0"  (click)="toggleInnerDetails(idx)" class="cursor-pointer">
                    <td class="bold-text">{{ alert?.client_name || "N/A" }}</td>
                    <td  class="bold-text"> {{ alert?.client_sub_total || "N/A" }}</td>
                    <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                      <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                              [ngClass]="{'rotate-180': activeInnerIndex === idx}" 
                              (click)="$event.stopPropagation(); toggleInnerDetails(idx)">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
                          <path
                            d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
                            fill="#0F0F0F"></path>
                        </svg>
                        </button>
                        </td>
                        </tr>
                        
                        <!-- First Child Table (Remove button column and adjust click) -->
                        <tr *ngIf="activeInnerIndex === idx && !isLoading">
                          <td colspan="3">
                            <div class="p-3">
                              <table class="w-100 left-align-color left-align-table">
                                <thead style="background-color: #0066bf; color: white;">
                                  <tr>
                                    <th>Site Name</th>
                                    <th>Application Name</th>
                                    <th>Asset Name</th>
                                    <th>Device Serial No.</th>
                                    <th>Mac Address</th>
                                    <th>Total Alerts</th>
                                    <th style="width: 50px;"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let detail of alert.alerts" (click)="openModal(detail)">
                                    <td>{{ detail?.site_name || "N/A" }}</td>
                                    <td>{{ detail?.application_name || "N/A" }}</td>
                                    <td>{{ detail?.asset_name || "N/A" }}</td>
                                    <td>{{ detail?.device_serial_no || "N/A" }}</td>
                                    <td>{{ detail?.mac_address || "N/A" }}</td>
                                    <td>{{ detail?.count || "N/A" }}</td>
                                    <td class="d-flex justify-content-center align-items-center" style="padding: 0; width: 50px;">
                                      <button class="btn btn-link p-0 d-flex justify-content-center align-items-center"
                                        [ngClass]="{'active-eye': activeIndex === subIdx}"
                                        (click)="$event.stopPropagation(); openModal(detail,subIdx)">
                                        <svg viewBox="0 0 24 24" width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path *ngIf="activeIndex !== subIdx"
                                            d="M12 4.5C7.455 4.5 3.733 7.418 2 12c1.733 4.582 5.455 7.5 10 7.5s8.267-2.918 10-7.5c-1.733-4.582-5.455-7.5-10-7.5Zm0 12.5c-2.627 0-4.75-2.123-4.75-4.75S9.373 7.5 12 7.5s4.75 2.123 4.75 4.75-2.123 4.75-4.75 4.75Zm0-2c1.518 0 2.75-1.232 2.75-2.75S13.518 9.5 12 9.5 9.25 10.732 9.25 12.25 10.482 15 12 15Z"
                                            fill="#0F0F0F" />
                                          <path *ngIf="activeIndex === subIdx"
                                            d="M12 3C7 3 2.732 6.732 1 12c1.732 5.268 6 9 11 9s9.268-3.732 11-9c-1.732-5.268-6-9-11-9Zm0 15c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6Zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Z"
                                            fill="#0066bf" />
                                        </svg>
                                      </button>
                        
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                        
                        <!-- Full Screen Modal -->
                        <div *ngIf="selectedAlert" class="modal-overlay" (click)="closeModal()">
                          <div class="modal-content" (click)="$event.stopPropagation()">
                            <!-- Fixed Close Button with Cross -->
                            <button class="cancel-button" (click)="closeModal()">
                              <span class="cross-icon">&times;</span>
                            </button>
                        
                            <!-- Fixed Table Header -->
                           
                            
                            <!-- Fixed Header Table -->
                            <div class="fixed-header">
                              <table class="table-fixed left-align-color left-align-table">
                                <thead style="background-color: #0066bf; color: white;">
                                  <tr>
                                    <th class="col-details">Alert Details</th>
                                    <th class="col-datetime">Date &amp; Time</th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                            
                            <!-- Scrollable Body Table -->
                            <div class="scrollable-body">
                              <table class="table-fixed left-align-color left-align-table">
                                <tbody>
                                  <tr *ngFor="let alertDetail of selectedAlert.data">
                                    <td class="col-details">{{ alertDetail?.alert_details || "N/A" }}</td>
                                    <td class="col-datetime">{{ formatDate(alertDetail?.alert_time) || "N/A" }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            
                          </div>
                        </div>
                        </ng-container>
                        </ng-template>
                        </tbody>
                        </table>
                        
                        </div>
                        </div>
                        </div>
                        
                        
                        
                        <div *ngIf="isLoading">
                          <div *ngFor="let i of [].constructor(20); let idx = index" class="skeleton skeleton-text w-100"></div>
                        </div>
                        
                        <!-- Add a message when no records are available -->
                        <div *ngIf="processedData?.length == 0 && !isFiltered && !isLoading">
                          <p class="text-center">No records available.</p>
                        </div>
                        <!--   
                          <div class="button-container">
                            <button
                              class="custom_button"
                              mat-raised-button
                              (click)="viewAuditReports()"
                              [disabled]="
                                reportDataArr?.length === 0 || (showEmptyError !== '' && filtersApplied)
                              "
                            >
                              Print / Save as PDF
                            </button>
                          </div> -->
                        
                        <div *ngIf="" class="d-flex justify-content-center">
                          <mat-paginator [length]="reportDataArr.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[5, 10, 20, 50]"
                            (page)="onPageChange($event)">
                          </mat-paginator>
                        </div>
                        </div>
